import axios from '@/axios';

const RESOURCE_NAME = '/admin/markets/partnerships';

export default {
    getIndexList(data) {
        return axios.post(`${RESOURCE_NAME}/get-index-list`, data)
    },

    getEdit(id) {
        return axios.get(`${RESOURCE_NAME}/get-edit?id=${id}`)
    },

    save(id, data) {
        return axios.post(`${RESOURCE_NAME}/save?id=${id}`, data)
    },

    delete(id) {
        return axios.post(`${RESOURCE_NAME}/delete-partnership?id=${id}`)
    },

    exportRecords(data) {
        return axios.post(`${RESOURCE_NAME}/export-records`, data)
    }
}
